import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-add-salon',
  templateUrl: './add-salon.component.html',
  styleUrls: ['./add-salon.component.css']
})
export class AddSalonComponent implements OnInit {

  currentUser: any = {};
  model: any = {};
  users: any[] = [];
  parentSalons: any[] = [];
  mainSalons: any[] = [];
  showLoader: boolean = false;
  headerLabel: string = 'New';
  isEdit: boolean = false;
  selectedUserIndex: number = -1;
  userModel: any = {};
  showUserForm: boolean = false;
  defaultModuleAccess: string = '';
  showSalonForm: boolean = true;
  selectedLogoFile: File | null = null;
  selectedLogoFile1: File | null = null;
  logoPreview: string = '';
  logoPreview1: string = '';

  userTypes = [
    { id: '0', name: 'Admin' },
    { id: '1', name: 'Manager' },
    { id: '2', name: 'Accountant' }
  ];
  how_do: any = [];
  stock_location_do: any = [];
  stock_area_do: any = [];

  constructor(
    private router: Router,
    private loginservice: LoginService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService
  ) { }

  ngOnInit(): void {
    this.currentUser = this.initializeCurrentUser();
    if (!this.currentUser || Object.keys(this.currentUser).length === 0) {
      this.router.navigate(['/login']);
      return;
    }

    this.initializeModel();
    this.loadModuleAccess();

    this.getAllhow();
    this.getAllstock_location();
    this.getAllstock_area();

    this._arout.params.subscribe(p => {
      if (p.salon_id) {
        this.headerLabel = 'Edit';
        this.isEdit = true;
        this.loadSalonData(p.salon_id);
      } else if (p.mode === 'users') {
        // Only user management for salon admin
        this.showSalonForm = false;
        this.headerLabel = 'Manage Users';
        this.loadCurrentSalonUsers();
      }
      // Check permissions after route params are set
      this.checkPermissions();
    }, error => { alert('Network Error params API'); });

    setTimeout(() => { this.model.how = ''; this.model.stock_location = ''; this.model.stock_area = ''; }, 1000); // Default to empty to show select dropdown

  }

  private initializeCurrentUser(): any {
    try {
      const sessionData = this.loginservice && this.loginservice.getLocalSession ? this.loginservice.getLocalSession('currentUser') : null;
      if (sessionData && typeof sessionData === 'string') {
        return JSON.parse(sessionData);
      }
      return {};
    } catch (error) {
      console.error('Error parsing session data:', error);
      return {};
    }
  }

  checkPermissions() {
    if (this.currentUser.superAdmin == 1) {
      // Super admin can do everything
      this.loadParentSalons();
    } else if (this.currentUser.userType == 0) {
      // Salon admin can only edit their salon and manage users
      if (this.isEdit) {
        // Check if they're editing their own salon
        // this._arout.params.subscribe(p => {
        //   if (p.salon_id && p.salon_id != this.currentUser.salon_id) {
        //     this._flashMessagesService.show('Access denied. You can only edit your own salon.', { cssClass: 'alert-danger' });
        //     this.router.navigate(['/manageSalons']);
        //   }
        // });
      } else {
        // Can't create new salons
        this._flashMessagesService.show('Access denied. Only super admin can create new salons.', { cssClass: 'alert-danger' });
        this.router.navigate(['/manageSalons']);
      }
    } else {
      // Other users have no access
      this._flashMessagesService.show('Access denied', { cssClass: 'alert-danger' });
      this.router.navigate(['/manageSalons']);
    }
  }

  initializeModel() {
    this.model = {
      salonName: '',
      addCredits: 500,
      highlight: '',
      location: '',
      ownerName: '',
      cntactPhone: '',
      isBranch: 0,
      incomingMessage: 0,
      marketingCredits: 0,
      utilityCredits: 0,
      credits: 0,
      parentSalonId: 0,
      parentSalonName: '',
      branchName: '',
      logo: '',
      billLogo: '',
      service_percent: 0,
      product_percent: 0,
      status: 1
    };
    this.users = [];
  }

  loadModuleAccess() {
    this.defaultModuleAccess = this.currentUser.module_access || '';
  }

  loadParentSalons() {
    // Load only main salons (non-branch salons) for branch creation
    this.loginservice.getSalons('main', this.currentUser).subscribe(
      data => {
        this.mainSalons = (data['salons'] || []).filter(salon => salon.isBranch == 0);
      },
      error => {
        alert('Network Error getSalons API');
        console.error('Error loading main salons:', error);
      }
    );
  }

  loadCurrentSalonUsers() {
    // Load users for current salon only
    this.showLoader = true;
    this.loginservice.getSalonUsers(this.currentUser.salon_id, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.users = data['users'] || [];
        }
        this.showLoader = false;
      },
      error => {
        alert('Network Error getSalonUsers API');
        console.error('Error loading users:', error);
        this.showLoader = false;
      }
    );
  }

  loadSalonData(salonId: string) {
    this.showLoader = true;
    this.loginservice.getSalonDetails(salonId, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          const salon = data['salon'];
          this.model = { ...salon, addCredits: 500 };
          this.users = data['users'] || [];
        }
        this.showLoader = false;
      },
      error => {
        alert('Network Error getSalonDetails API');
        console.error('Error loading salon data:', error);
        this.showLoader = false;
      }
    );
  }

  saveSalon() {
    if (!this.isSuperAdmin()) {
      this._flashMessagesService.show('Access denied', { cssClass: 'alert-danger' });
      return;
    }

    if (!this.validateSalon()) return;

    this.showLoader = true;
    const salonData = {
      ...this.model,
      users: this.users
    };

    this.loginservice.saveSalon(salonData, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this.currentUser.logo = data['logo'];
          this.currentUser.billLogo = data['billLogo'];
          this.loginservice.setLocalSession(this.currentUser, 'currentUser');
          this._flashMessagesService.show('Salon saved successfully', { cssClass: 'alert-success' });
          window.location.reload();
          this.router.navigate(['/manageSalons']);
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        alert('Network Error saveSalon API');
        this._flashMessagesService.show('Error saving salon', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }

  saveUsers() {
    // Save users only (for salon admin)
    this.showLoader = true;
    this.loginservice.saveSalonUsers(this.currentUser.salon_id, this.users, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Users saved successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        alert('Network Error saveSalonUsers API');
        this._flashMessagesService.show('Error saving users', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }

  validateSalon(): boolean {
    if (!this.model.salonName.trim()) {
      this._flashMessagesService.show('Salon name is required', { cssClass: 'alert-danger' });
      return false;
    }
    if (!this.model.location.trim()) {
      this._flashMessagesService.show('Location is required', { cssClass: 'alert-danger' });
      return false;
    }
    if (!this.model.ownerName.trim()) {
      this._flashMessagesService.show('Owner name is required', { cssClass: 'alert-danger' });
      return false;
    }
    return true;
  }

  // User Management Methods
  addUser() {
    this.userModel = {
      username: '',
      user_id: '',
      name: '',
      email: '',
      phone: '',
      password: '',
      user_type: 0,
      // module_access: '',
      module_access: this.defaultModuleAccess,
      user_status: 1
    };
    this.selectedUserIndex = -1;
    this.showUserForm = true;
  }

  editUser(index: number) {
    this.userModel = { ...this.users[index] };
    this.selectedUserIndex = index;
    this.showUserForm = true;
  }

  saveUser() {
    if (!this.validateUser()) return;
    this.loginservice.CheckUsername(this.userModel).subscribe(
      data => {
        if (data['status'] === 'success') {
          if (this.selectedUserIndex >= 0) {
            this.users[this.selectedUserIndex] = { ...this.userModel };
          } else {
            this.users.push({ ...this.userModel });
          }
          this.cancelUserForm();
        } else {
          this._flashMessagesService.show('Username already exists', { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error CheckUsername API'); });
  }

  deleteUser(index: number, user) {
    if (user.user_id && user.user_id !== '') {
      if (confirm('Are you sure you want to delete this user?')) {
        this.loginservice.deleteUser(user.user_id).subscribe(
          data => {
            if (data['status'] === 'success') {
              this.users.splice(index, 1);
            } else {
              this._flashMessagesService.show('error', { cssClass: 'alert-danger' });
            }
          }, error => { alert('Network Error deleteUser API'); });
      }
    } else {
      this.users.splice(index, 1);
    }
  }

  validateUser(): boolean {
    if (!this.userModel.username.trim()) {
      this._flashMessagesService.show('Username is required', { cssClass: 'alert-danger' });
      return false;
    }
    if (!this.userModel.name.trim()) {
      this._flashMessagesService.show('Name is required', { cssClass: 'alert-danger' });
      return false;
    }
    if (!this.userModel.email.trim()) {
      // this._flashMessagesService.show('Email is required', { cssClass: 'alert-danger' });
      // return false;
    }
    if (!this.userModel.password.trim()) {
      this._flashMessagesService.show('Password is required', { cssClass: 'alert-danger' });
      return false;
    }
    return true;
  }

  cancelUserForm() {
    this.showUserForm = false;
    this.userModel = {};
    this.selectedUserIndex = -1;
  }

  copyModuleAccess() {
    if (confirm('Copy module access from current user?')) {
      this.userModel.module_access = this.defaultModuleAccess;
      this._flashMessagesService.show('Module access copied', { cssClass: 'alert-success' });
    }
  }

  onBranchChange() {
    if (this.model.isBranch == 1) {
      this.loadParentSalons();
    } else {
      this.model.parentSalonId = 0;
      this.model.parentSalonName = '';
      this.model.branchName = '';
    }
  }

  onParentSalonChange() {
    const selectedSalon = this.mainSalons.find(salon => salon.id == this.model.parentSalonId);
    if (selectedSalon) {
      this.model.parentSalonName = selectedSalon.salonName;
    } else {
      this.model.parentSalonName = '';
    }
  }

  isSuperAdmin(): boolean {
    return this.currentUser.superAdmin == 1;
  }

  isSalonAdmin(): boolean {
    return this.currentUser.userType == 0 && this.currentUser.superAdmin != 1;
  }

  onLogoFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.selectedLogoFile = file;

        // Create preview
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.logoPreview = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this._flashMessagesService.show('Please select an image file', { cssClass: 'alert-danger' });
      }
    }
  }

  onLogoFileSelected1(event: any) {
    const file = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.selectedLogoFile1 = file;

        // Create preview
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.logoPreview1 = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this._flashMessagesService.show('Please select an image file', { cssClass: 'alert-danger' });
      }
    }
  }

  uploadLogo() {
    if (!this.selectedLogoFile) return;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('logo', this.selectedLogoFile);

    this.loginservice.uploadSalonLogo(formData, 'salon_logo').subscribe(
      data => {
        if (data['status'] === 'success') {
          this.model.logo = data['filename'];
          this._flashMessagesService.show('Logo uploaded successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show('Error uploading logo', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error uploading logo', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }


  uploadLogo1() {
    if (!this.selectedLogoFile1) return;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('logo', this.selectedLogoFile1);

    this.loginservice.uploadSalonLogo(formData, 'billLogo').subscribe(
      data => {
        if (data['status'] === 'success') {
          this.model.billLogo = data['filename'];
          this._flashMessagesService.show('Bill logo uploaded successfully', { cssClass: 'alert-success' });
        } else {
          this._flashMessagesService.show('Error uploading bill logo', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error uploading bill logo', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }

  getUserTypeName(userType) {
    const type = this.userTypes.find(t => t.id.toString() === userType.toString());
    return type ? type.name : 'Unknown';
  }

  goBack() {
    this.router.navigate(['/manageSalons']);
  }



  getAllhow() {
    this.loginservice.getAllhow(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success' && data['data'].length > 0) {
          this.how_do = data['data'];
        }
      });
  }

  cancelAddbrandHow() {
    this.model.how = '';
    this.model.how_name = '';
  }


  deleteHow(how) {
    var result = confirm("Want to delete?");
    if (result) {
      this.loginservice.deleteHow(how, this.currentUser).subscribe(data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.cancelAddbrandHow();
          this.getAllhow();
        } else {
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        }
      },
        error => {
          alert('Network Error deleteHow API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
    }
  }

  Addhow(how_name) {
    this.loginservice.Addhow(how_name, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
          this.cancelAddbrandHow();
          // Reload the how_do list
          this.getAllhow();
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error AddHow API'); });
  }

  onHowChange() {
    if (this.model.how === '0') {
      this.model.how_name = '';
    }
  }


  getAllstock_location() {
    this.loginservice.getAllstock_location(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success' && data['data'].length > 0) {
          this.stock_location_do = data['data'];
        }
      });
  }

  cancelAddstock_location() {
    this.model.stock_location = '';
    this.model.stock_location_name = '';
  }


  deleteStockLocation(stock_location) {
    var result = confirm("Want to delete?");
    if (result) {
      this.loginservice.deleteStockLocation(stock_location, this.currentUser).subscribe(data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.cancelAddstock_location();
          this.getAllstock_location();
        } else {
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        }
      },
        error => {
          alert('Network Error deleteStockLocation API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
    }
  }

  Addstock_location(stock_location_name) {
    this.loginservice.Addstock_location(stock_location_name, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
          this.cancelAddstock_location();
          // Reload the stock_location_do list
          this.getAllstock_location();
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error AddStockLocation API'); });
  }

  onStockLocationChange() {
    if (this.model.stock_location === '0') {
      this.model.stock_location_name = '';
    }
  }

  getAllstock_area() {
    this.loginservice.getAllstock_area(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success' && data['data'].length > 0) {
          this.stock_area_do = data['data'];
        }
      });
  }


  cancelAddstock_area() {
    this.model.stock_area = '';
    this.model.stock_area_name = '';
  }


  deleteStockArea(stock_area) {
    var result = confirm("Want to delete?");
    if (result) {
      this.loginservice.deleteStockArea(stock_area, this.currentUser).subscribe(data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.cancelAddstock_area();
          this.getAllstock_area();
        } else {
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        }
      },
        error => {
          alert('Network Error deleteStockArea API');
          this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        });
    }
  }

  Addstock_area(stock_area_name) {
    this.loginservice.Addstock_area(stock_area_name, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
          this.cancelAddstock_area();
          // Reload the stock_area_do list
          this.getAllstock_area();
        } else {
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
        }
      }, error => { alert('Network Error AddStockArea API'); });
  }

  onStockAreaChange() {
    if (this.model.stock_area === '0') {
      this.model.stock_area_name = '';
    }
  }

  recharge(addCredits, currentUser) {
    if (addCredits >= 500) {
      if (confirm("Are you sure to recharge of amount ₹" + addCredits)) {
        this.loginservice.recharge(addCredits, currentUser).subscribe(data => {
          if (data['status'] === 'success') {
            this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
            alert(data['message']);
            this.currentUser.credits = data['credit'];
            this.loginservice.setLocalSession(this.currentUser, 'currentUser');
          }
        });
      }
    } else {
      this._flashMessagesService.show('Minimum Recharge should be 500', { cssClass: 'alert-danger' });
      alert('Minimum Recharge should be 500')
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/add-salon/add-salon.component.ts